import React from 'react';
import { Link } from 'react-router-dom';

import hdlccLogo from '../../assets/HDLCC.avif';

function Header() {
  return (
    <header className="bg-hdlcc-black">
      {/* Logo and Title Section */}
      <div className="container mx-auto px-4 py-6 text-center">
        <Link to="/" className="inline-block">
          <img src={hdlccLogo} alt="HDLCC Logo" className="h-24 mx-auto mb-4" />
          <h1 className="text-white text-2xl font-bold">
            HAGLEY & DISTRICT LIGHT CAR CLUB MEMBERSHIP
          </h1>
        </Link>
      </div>
    </header>
  );
}

export default Header;
